import makeStyles from '@mui/styles/makeStyles';

const useSettingsStyles = makeStyles({
  root: {
    "& MuiPickersDay-daySelected": {
      backgroundColor: "white",
      boxShadow: "4px 4px 15px rgba(0, 0, 0, 0.05)",
      borderRadius: "50px",
      border: "none",
      "&:hover": {
        backgroundColor: "white",
        border: "none",
      },
    },
    
    "& .MuiInputBase-root": {
      color: "#000",
      backgroundColor: "transparent",
      borderRadius: "50px",
      border: "none",
      fontSize:'12px'
    },
    "& MuiPickersDay-daySelected": {
      backgroundColor: "white",
      border: "none",
      "&:hover": {
        backgroundColor: "white",
        border: "none",
      },
    },
    "& .MuiFormLabel-root":{
      backgroundColor: "#fff",
      padding: "0px 6px 0px 6px",
      borderRadius:"10px"
    },
  }
});

export default useSettingsStyles;
